import { render, staticRenderFns } from "./userBlacklistMa.vue?vue&type=template&id=421b141c&"
import script from "./userBlacklistMa.vue?vue&type=script&lang=js&"
export * from "./userBlacklistMa.vue?vue&type=script&lang=js&"
import style0 from "./userBlacklistMa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports